import { render, staticRenderFns } from "./RegisterDocumentList.vue?vue&type=template&id=62df7bfa&scoped=true"
import script from "./RegisterDocumentList.vue?vue&type=script&lang=js"
export * from "./RegisterDocumentList.vue?vue&type=script&lang=js"
import style0 from "./RegisterDocumentList.vue?vue&type=style&index=0&id=62df7bfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df7bfa",
  null
  
)

export default component.exports